import Portal from "./Portal";
import { inlineMock } from "./mock";
export { inlineMock };
export default Portal;